
import { Component, Vue } from 'vue-property-decorator';
import { Icon, Popconfirm } from 'ant-design-vue';


@Component({
    name: 'GenericDeletePopconfirm',
    components: {Popconfirm, Icon},
})
export default class GenericDeletePopconfirm extends Vue {
}
